import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import ResetPasswordStatusPage from './ResetPasswordStatusPage';

const _mapStateToProps = ({ authentication }) => ({
    email: authentication.email,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

export default withRouter(connect(_mapStateToProps)(ResetPasswordStatusPage));
